export default "__VITE_PUBLIC_ASSET__96432daf__"